import { SELECTEDTAB_INDEX } from 'state/selectedTab/constants';

export function getID(state, index) {
  let tabIndex = index !== undefined ? index : SELECTEDTAB_INDEX;
  return state.tabs[tabIndex].id;
}

export const createTabId = () =>
  new Date().getTime() + Math.round(Math.random() * 1000);
